import Vue from 'vue';
import axios from 'axios/index';

class GDPR {
  constructor() {
    Vue.prototype.$gdpr = this;
  }

  showBanner() {
    window.trans = (key) => {
      if (key === 'cookieconsent.copy') {
        return 'This site uses cookies for analytics, personalized content and ads. By continuing to browse this site, you agree to this use.';
      }

      return 'Learn More';
    };

    axios.get('https://www.domo.com/getPartial/geoip_country_code')
      .then((response) => {
        const countryCode = response.data.country;
        if (window.Domo && window.Domo.gdpr && (countryCode !== 'US' && countryCode !== 'JP') && !document.cookie.match(/\bnotice_gdpr_prefs=/)) {
          window.Domo.gdpr.initBanner();
        }
      })
      .catch((e) => {
        console.log(e.message);
        console.error('Unable to get GeoIP.');
      });

    return this;
  }
}

export default {
  install() {
    return new GDPR();
  },
};
